import React, { useEffect } from 'react';
import { globalHistory } from '@reach/router';
import { MdRecordVoiceOver } from 'react-icons/md';
import { useSpeechSynthesis } from 'react-speech-kit';
import VoiceStop from '../components/VoiceStop';

export const useVoice = () => {
  const { speak, cancel, speaking } = useSpeechSynthesis();
  const handleSpeech = (text) => {
    if (speaking) return cancel();
    speak({ text });
  };

  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') cancel();
    });
  }, [speaking]);

  const VoiceElement = ({ text }) => (
    <>
      <MdRecordVoiceOver
        onClick={() => handleSpeech(text)}
        className={`soundButton ${speaking ? 'active' : ''}`}
        title='Click to Speak'
      />
      {speaking && <VoiceStop onClick={cancel} />}
    </>
  );
  return VoiceElement;
};
